/**
 * @prettier
 */
import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

/** This component is meant to be used to wrap any content so it can be portaled somewhere else.
 * It also requires that you add a container component with the same id that you provide here as a prop
 * so the content can be rendered inside it
 * Alternatively - you can pass the append `true` prop and a container with the specified ID will be appended at the end of the body, and content portaled inside it
 */

class PortalContent extends React.Component {
  static propTypes = {
    /** Id for the portal target container, where content is to be portaled in. It **must exist** for the portal to work.
     *
     * If it doesn't exist then you must use the `append` prop */
    containerId: PropTypes.string.isRequired,
    /** Content to be portaled in the other place  */
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    /** Append a container with specified `containerID` the end of the body, and portal content inside it */
    append: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.container = null;
    this.el = document.createElement("div");
    this.domCheckerInterval = 0;
    this.getPortalContainer = this.getPortalContainer.bind(this);
  }

  componentDidMount() {
    if (!this.props.append) {
      this.domCheckerInterval = setInterval(this.getPortalContainer, 500);
    } else {
      this.el.setAttribute("id", this.props.containerId);
      document.body.appendChild(this.el);
    }
  }

  getPortalContainer() {
    this.container = document.getElementById(this.props.containerId);
    if (this.container !== null) {
      this.container.appendChild(this.el);
      clearInterval(this.domCheckerInterval);
    }
  }

  componentWillUnmount() {
    if (this.container) {
      this.container.removeChild(this.el);
    } else if (this.props.append) {
      document.body.removeChild(this.el);
    }
    clearInterval(this.domCheckerInterval);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default PortalContent;
